




function DashboardHeader() {
  return (
    <div className="header">
      <div>
        <h2>GIS & MPHS DATA MONITORING DASHBOARD</h2>
        <p>Water & Sewer Survey Status - 413 ULBs</p>
      </div>

      <div>
        <i className="fa-solid fa-map-location-dot header-icon"></i>
      </div>
    </div>
  );
}

export default DashboardHeader;